module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAGUlEQVQoU2OcOXPmfwYiAOOoQnyhRP3gAQBRcxvvGcLKkQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/resource-icon-juxing-gray.png
// module id = Q4yr
// module chunks = 2